import { createFileRoute } from "@tanstack/react-router";
import { PlaybookSteps } from "../../../components/playbooks/playbook-tabs";
import { playbookStepsSearchSchema } from "../../../lib/playbooks/page";

/**
 * Steps, with `?step=` opening that step in place (a step's own address), `?view=map` the Map, and
 * `?table=` unfolding a table under the steps, as a chat card's table chip asks.
 */
export const Route = createFileRoute("/_authenticated/_workspace/playbooks/$playbookId/steps")({
  validateSearch: playbookStepsSearchSchema,
  component: function PlaybookStepsRoute() {
    const { playbookId } = Route.useParams();
    const { step, view, table } = Route.useSearch();
    return (
      <PlaybookSteps
        playbookId={playbookId}
        step={step ?? null}
        view={view ?? "list"}
        table={table ?? null}
      />
    );
  },
});
